import * as React from 'react';
import { Button, Typography } from '@symphony-ui/uitoolkit-components';
import './CardHeader.css';
const CardHeaderTable = ({ create, disabled, title }) => (React.createElement("div", { className: "co-header-main" },
    React.createElement(Typography, { type: "h1" }, title),
    React.createElement(Button, { disabled: disabled, onClick: create }, "CREATE NEW")));
export default CardHeaderTable;
